export const scrollElementIntoView = (
	element: HTMLElement | null = null,
	block: 'center' | 'start' | 'end' | 'nearest' = 'center',
) => {
	if (!element) {
		return;
	}

	element.scrollIntoView({
		behavior: 'smooth',
		block,
	});
};
